
import React from "react";
import {getHypFakeData, getHypKeys, UploadTextBlobs} from "../../onboarding/actions";
import {Action, TextLoading} from "../../funcs/utils";
import {HYPERVERGE_STATE} from "../../../lib/hyperverge-constants";
import uuidv4 from "uuid/v4";
import {HypervergeDialog} from "./hyperverge-dialog";
import {logUserEvent} from "../../app/actions";
import {UserEvents} from "../../../lib/user-events";

const Mode = {
  USER_CANCELLED: "USER_CANCELLED",
  HYPERVERGE_ERROR: "HYPERVERGE_ERROR",
}

class Hyperverge extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      token: "",
      workflow_id: "",
      loading: false,
      mode: null,
    }
  }

  launch = () => {
    this.setState({
      loading: true,
    });
    const hyp_version = this.props.onboardingComponent.getOnboardingData().kyc_switch;
    getHypKeys(this.props.token, this.props.onboarding_token, hyp_version)
      .then(result => {
        this.setState({
          loading: false,
          token: result.token,
          workflow_id: result.workflow_id,
        });

        try {
          // Get a config instance
          const transaction_id = uuidv4();
          console.log("launching transactionID", transaction_id);
          const hyperKycConfig = new window.HyperKycConfig(
            result.token, result.workflow_id, transaction_id);
          window.HyperKYCModule.launch(hyperKycConfig, this.handler);

          logUserEvent(__filename, UserEvents.KYC_START, {
            username: this.props.onboardingComponent.props.user.username,
            index: this.props.onboardingComponent.getOnboardingIndex(),
          }).then();
        } catch (err) {
          console.log("ERROR", err);
        }

      })
  }

  /**
   * If {@param details} contains idPhoto or selfiePhoto, then
   * upload them, and remove from details.
   *
   * @returns an array of s3 paths to uploaded files
   */
  maybeUploadImages = (details) => {

    if (!details) {
      return;
    }

    // return the string after the first ','
    const drop_prefix = str => {
      const comma_index = str.indexOf(",");
      if (comma_index === -1) {
        return str;
      }
      return str.substring(comma_index + 1);
    }

    const docusign_files = [];

    const fields = [];
    if (details.idPhoto) {
      docusign_files.push("kyc/idPhoto.jpg");
      fields.push({
        data: drop_prefix(details.idPhoto),
        filename: "idPhoto.jpg",
      });
      delete details.idPhoto;
    }
    if (details.selfiePhoto) {
      docusign_files.push("kyc/selfiePhoto.jpg");
      fields.push({
        data: drop_prefix(details.selfiePhoto),
        filename: "selfiePhoto.jpg",
      });
      delete details.selfiePhoto;
    }

    if (fields.length > 0) {
      UploadTextBlobs(
        this.props.token,
        this.props.onboarding_token,
        "base64",
        "kyc",
        fields,
        this.props.onboardingComponent.getOnboardingIndex())
        .then();
    }
    return docusign_files;
  }

  handler = (result) => {
    console.log("Hyperverge result", result);
    const uploaded_files = this.maybeUploadImages(result.details);
    //console.log("handler results", JSON.stringify(result, null, 2));
    switch(result.status) {
      case "user_cancelled":
        this.setState({ mode: Mode.USER_CANCELLED });
        logUserEvent(__filename, UserEvents.KYC_CANCEL, {
          username: this.props.onboardingComponent.props.user.username,
          index: this.props.onboardingComponent.getOnboardingIndex(),
        }).then();
        break;
      case "error":
        this.setState({ mode: Mode.HYPERVERGE_ERROR });
        break;
        // TODO: Handle the failure cases to tell the user what's missing
        // and to try again.
      case "auto_approved":
      case "auto_declined":
      case "needs_review":
        logUserEvent(__filename, UserEvents.KYC_END, {
          username: this.props.onboardingComponent.props.user.username,
          index: this.props.onboardingComponent.getOnboardingIndex(),
        }).then();
        // Whether we require further review, or if we are declined,
        // we still continue the onboarding.
        this.props.onSave(result, uploaded_files);
        break;
      default:
        console.log("UNHANDLED CASE", result.status);
    }
  }

  handleApproval = (orig_data, uploaded_files) => {
    const onboarding = this.props.onboardingComponent.getOnboardingData();
    if (onboarding.kyc_switch === "dev_kyc") {
      getHypFakeData(
        this.props.token,
        this.props.onboarding_token)
        .then(user_data => {
          const new_data = Object.assign(orig_data, user_data);
          this.props.onSave(new_data, uploaded_files);
        });

    } else {
      this.props.onSave(orig_data, uploaded_files);
    }
  }

  renderButton = () => {
    const onboarding = this.props.onboardingComponent.getOnboardingData();
    if (onboarding.hyperverge && onboarding.hyperverge.state
      !== HYPERVERGE_STATE.INIT) {
      return null;
    }

    return (
      <div align={"center"}>
        <div style={{ height: "2rem"}}/>
        <Action onClick={() => this.launch()}>
          <TextLoading
            label={"Let's Begin"}
            loading={this.state.loading}/>
        </Action>
        <div style={{ height: "2rem"}}/>
        { false && <Action onClick={() => this.handleApproval()}>
          Skip
        </Action> }
      </div>
    )
  }

  onDialogClick = () => {
    this.setState({ mode: null });
    console.log("click");
  }

  render = () => {
    let modal;
    if (this.state.mode === Mode.USER_CANCELLED) {
      modal = (
        <HypervergeDialog
          on_click={this.onDialogClick}
          lines={[
            "You ended your session early.",
            "Please try again."
          ]}/>);
    } else if (this.state.mode === Mode.HYPERVERGE_ERROR) {
      modal = (
        <HypervergeDialog
          on_click={this.onDialogClick}
          lines={[
            "There appears to be an error.",
            "Please try again."
          ]}/>);
    }

    return (
      <div>
        { this.renderButton() }
        { modal }
      </div>
    )
  }

}

export { Hyperverge };
